import { connect } from 'react-redux'
//import { state_update } from '../actions'
//import LeftPanel from './LeftPanel'
import MainBodyPortrait from './MainBodyPortrait';
import { state_start_over,state_update } from '../actions'
import {decodeHtml} from '../reducers/utils'
import ReactGA from 'react-ga';

const mapStateToProps = (state, ownProps) => ({
  title:decodeHtml(state['title']),
  cfg:state['cfg1'],
  showSticky:state['showSticky'] ? false: true
  
})
  
 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onStartOver: ( () =>{
    ReactGA.event({
      category: 'StartOver',
      action:'StartOver' 
    });
    dispatch(state_start_over())}),
  onPushOpenBox: ( () =>{
    ReactGA.event({
      category: 'Zoom',
      action:'Zoom' 
    });
    dispatch(state_update({attr:'pushOpenBox',value:true}))})
  //onClick: ( () => dispatch(state_update({attr:ownProps.attr,value:ownProps.value})))
//  onClick: ( () => dispatch(state_update({attr:'review',value:false})))
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainBodyPortrait)


// WEBPACK FOOTER //
// ./src/layout/MainBodyPortraitWrap.js